import { useEffect, useRef, useState } from "react";

interface UseInViewOptions {
  triggerOnce?: boolean;
  rootMargin?: string;
}

interface UseInViewResult {
  ref: React.RefObject<HTMLDivElement>;
  inView: boolean;
}

export function useInView({
  triggerOnce = false,
  rootMargin = "0px",
}: UseInViewOptions = {}): UseInViewResult {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // Fallback for environments where IntersectionObserver is not available (e.g. jsdom)
    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (triggerOnce) observer.disconnect();
        } else if (!triggerOnce) {
          setInView(false);
        }
      },
      { rootMargin },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [triggerOnce, rootMargin]);

  return { ref, inView };
}
